import { createContext } from 'react'

export const FormsChromeContext = createContext(null)
